export default __webpack_public_path__ + "static/media/screen6.cf8b699b.png";